// Mesej guest ↔ host. Polling setiap 5 saat semasa perbualan dibuka (kebenaran disemak di Worker).

import { html, mount } from '../core/html.js';
import { get, post, session } from '../core/api.js';
import { emptyState, showError, initials } from '../core/ui.js';
import { fmtTs } from '../core/format.js';
import { t } from '../core/i18n.js';

export async function render(main, { id }) {
  const convs = await get('/api/conversations');
  const wide = window.innerWidth >= 900;
  mount(main, html`<div class="wrap" style="padding-top:20px"><h1>${t('messages.title')}</h1>
    <div style="display:grid;gap:16px;grid-template-columns:${wide ? '320px 1fr' : '1fr'}">
      ${!id || wide ? html`<div class="list" aria-label="${t('messages.list_aria')}">${convs.length ? convs.map((c) => html`<a class="item" href="#/messages/${c.id}" aria-current="${c.id === id ? 'page' : null}" style="${c.id === id ? 'border-color:var(--hutan)' : ''}">
        <span class="avatar">${initials(c.property_name)}</span><span class="grow"><b data-ugc>${c.property_name}</b><div class="small muted" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap" data-ugc>${c.last_message}</div><div class="tiny muted">${c.role === 'HOST' ? t('messages.you_host') : t('messages.you_guest')}, ${fmtTs(c.last_message_at)}</div></span>
        ${c.unread_count ? html`<span class="badge-dot">${c.unread_count}</span>` : ''}</a>`) : emptyState(t('messages.empty_title'), t('messages.empty_text'))}</div>` : ''}
      ${id ? html`<div id="thread"></div>` : wide ? html`<div class="panel soft empty">${t('messages.pick')}</div>` : ''}
    </div></div>`);
  if (!id) return;
  const box = main.querySelector('#thread');
  let last = 0;
  let stopped = false;
  const { conversation, messages } = await get(`/api/conversations/${id}/messages`);
  mount(box, html`${!wide ? html`<a href="#/messages" class="small">${t('messages.all')}</a>` : ''}<div class="chat"><div class="spread" style="padding:10px 14px;border-bottom:1px solid var(--garis)"><b>${conversation.property_name}</b>${conversation.booking_ids?.length ? html`<a class="small" href="#/bookings/${conversation.booking_ids[conversation.booking_ids.length - 1]}">${t('payreturn.view_booking')}</a>` : ''}</div>
    <div class="msgs" id="msgs" aria-live="polite"></div>
    <form id="send"><label class="sr" for="txt">${t('message.your_message')}</label><input class="input" id="txt" name="text" autocomplete="off" required maxlength="2000" placeholder="${t('messages.write_ph')}"><button class="btn btn-primary">${t('common.send')}</button></form></div>`);
  const list = box.querySelector('#msgs');
  const add = (ms) => {
    for (const m of ms) {
      const el = document.createElement('div');
      el.className = `bubble ${m.sender_id === session.me.uid ? 'me' : 'them'}`;
      const text = document.createElement('span');
      text.dataset.ugc = '';
      text.textContent = m.text;
      const time = document.createElement('time');
      time.textContent = fmtTs(m.created_at);
      el.append(text, time);
      list.appendChild(el);
      last = Math.max(last, m.created_at);
    }
    list.scrollTop = list.scrollHeight;
  };
  add(messages);
  post(`/api/conversations/${id}/read`).catch(() => {});
  box.querySelector('#send').onsubmit = async (e) => {
    e.preventDefault();
    const input = box.querySelector('#txt');
    const text = input.value.trim();
    if (!text) return;
    input.value = '';
    try { add([await post(`/api/conversations/${id}/messages`, { text })]); } catch (err) { input.value = text; showError(err); }
  };
  const poll = setInterval(async () => {
    if (stopped) return;
    try {
      const r = await get(`/api/conversations/${id}/messages?after=${last}`);
      if (r.messages.length) { add(r.messages.filter((m) => m.created_at > last || m.sender_id !== session.me.uid)); post(`/api/conversations/${id}/read`).catch(() => {}); }
    } catch { /* senyap */ }
  }, 5000);
  return () => { stopped = true; clearInterval(poll); };
}
